const StatusCodes = {
  REQUEST_TIMEOUT: 408,
}

export const checkTimedOut = ({ status }: { status: number }) =>
  status === StatusCodes.REQUEST_TIMEOUT
